var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"truncated-text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.wrapWords)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }